import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Warning from '../../assets/images/Warning.png';
import UserImg from '../../assets/images/user.png';
import StepOne from './steps/StepOne';
import axiosInstance from '../../api/axiosInstance';
import { use } from 'react';
import { useEffect } from 'react';
import axios from 'axios';

const PatientDetailsPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const imageData = location.state?.image;
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [patientMrno, setPatientMrno] = useState(null);
    const [patientId, setPatientId] = useState(null);

    //OTP STATES
    const [showOTPScreen, setShowOTPScreen] = useState(false);
    const [otp, setOtp] = useState('');
    const [otpLoading, setOtpLoading] = useState(false);
    const [otpError, setOtpError] = useState('');

    // NEW: Already Registered Dialog States
    const [showAlreadyRegisteredDialog, setShowAlreadyRegisteredDialog] = useState(false);
    const [dialogMessage, setDialogMessage] = useState('');
    const [dialogMobile, setDialogMobile] = useState('');

    const [showCameraModal, setShowCameraModal] = useState(false);
    const [capturedImage, setCapturedImage] = useState(null);
    const videoRef = React.useRef(null);
    const canvasRef = React.useRef(null);
    const streamRef = React.useRef(null);
    const [copyToWhatsapp, setCopyToWhatsapp] = useState(false);

    const toggleModal = () => setIsOpen(!isOpen);

    const [prefixes, setPrefixes] = useState([]);
    const [prefixesLoading, setPrefixesLoading] = useState(true);
    const [relations, setRelations] = useState([]);
    const [relationsLoading, setRelationsLoading] = useState(true);
    const [maritalStatuses, setMaritalStatuses] = useState([]);
    const [maritalStatusesLoading, setMaritalStatusesLoading] = useState(true);

    // Address dropdown states
    const [countries, setCountries] = useState([]);
    const [countriesLoading, setCountriesLoading] = useState(true);
    const [states, setStates] = useState([]);
    const [statesLoading, setStatesLoading] = useState(false);
    const [districts, setDistricts] = useState([]);
    const [districtsLoading, setDistrictsLoading] = useState(false);
    const [cities, setCities] = useState([]);
    const [citiesLoading, setCitiesLoading] = useState(false);

    // Searchable dropdown states
    const [countrySearch, setCountrySearch] = useState('');
    const [stateSearch, setStateSearch] = useState('');
    const [districtSearch, setDistrictSearch] = useState('');
    const [citySearch, setCitySearch] = useState('');
    const [showCountryDropdown, setShowCountryDropdown] = useState(false);
    const [showStateDropdown, setShowStateDropdown] = useState(false);
    const [showDistrictDropdown, setShowDistrictDropdown] = useState(false);
    const [showCityDropdown, setShowCityDropdown] = useState(false);

    // Refs for dropdown containers
    const countryRef = React.useRef(null);
    const stateRef = React.useRef(null);
    const districtRef = React.useRef(null);
    const cityRef = React.useRef(null);

    const [selectedGender, setSelectedGender] = useState('');
    const [selectedArea, setSelectedArea] = useState('urban');

    // Handle clicks outside dropdown to close them
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (countryRef.current && !countryRef.current.contains(event.target)) {
                setShowCountryDropdown(false);
            }
            if (stateRef.current && !stateRef.current.contains(event.target)) {
                setShowStateDropdown(false);
            }
            if (districtRef.current && !districtRef.current.contains(event.target)) {
                setShowDistrictDropdown(false);
            }
            if (cityRef.current && !cityRef.current.contains(event.target)) {
                setShowCityDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const [formData, setFormData] = useState({
        prefix: '',
        firstName: '',
        middleName: '',
        lastName: '',
        dob: '',
        age: '',
        ageSelect: 'year',
        mobileNumber: '',
        aadharNumber: '',
        email: '',
        area: 'urban',
        passportNo: '',
        visaNo: '',
        pincode: '751024',
        city: '',
        district: '',
        state: '',
        country: '',
        village: '',
        whatsappNumber: '',
        locality: '',
        postOffice: '',
        policeStation: '',
        nationality: 'Indian',
        relation: '',
        maritalStatus: '',
        emergencyContactNo: '',
        emergencyContactName: '',
        house: '',
        consentConfirmation: false,
    });

    // Handle clicks outside dropdown to close them
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (countryRef.current && !countryRef.current.contains(event.target)) {
                setShowCountryDropdown(false);
            }
            if (stateRef.current && !stateRef.current.contains(event.target)) {
                setShowStateDropdown(false);
            }
            if (districtRef.current && !districtRef.current.contains(event.target)) {
                setShowDistrictDropdown(false);
            }
            if (cityRef.current && !cityRef.current.contains(event.target)) {
                setShowCityDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Fetch prefixes from HIMS API
    useEffect(() => {
        const fetchPrefixes = async () => {
            try {
                setPrefixesLoading(true);
                const response = await axios.get(
                    `${process.env.REACT_APP_KIOSK_OPS_URL}/kiosk/prefixMaster`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('token')?.replace(/^"(.*)"$/, '$1')}`,
                        },
                    }
                );

                if (response.data && response.data.status === 'success' && Array.isArray(response.data.data)) {
                    // Map the API response to match the expected format
                    const mappedPrefixes = response.data.data.map((prefix) => ({
                        id: prefix.prefixId,
                        prefix_name: prefix.prefix,
                        genderId: prefix.genderId
                    }));
                    setPrefixes(mappedPrefixes);
                }
                setPrefixesLoading(false);
            } catch (error) {
                console.error("Error fetching prefixes:", error);
                // Fallback to default prefixes if API fails
                setPrefixes([
                    { id: 1030900, prefix_name: 'Mr', genderId: 1 },
                    { id: 1030901, prefix_name: 'Mrs', genderId: 2 },
                    { id: 1030902, prefix_name: 'Miss', genderId: 2 },
                    { id: 1030903, prefix_name: 'Ms', genderId: 2 },
                    { id: 1030904, prefix_name: 'Dr.', genderId: '' },
                ]);
                setPrefixesLoading(false);
            }
        };

        fetchPrefixes();
    }, []);

    // Fetch relations from HIMS API
    useEffect(() => {
        const fetchRelations = async () => {
            try {
                setRelationsLoading(true);
                const response = await axios.get(
                    `${process.env.REACT_APP_KIOSK_OPS_URL}/lookup/master?categoryName=RELATION`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('token')?.replace(/^"(.*)"$/, '$1')}`,
                        },
                    }
                );

                if (response.data && response.data.status === 'success' && Array.isArray(response.data.data)) {
                    setRelations(response.data.data);
                } else {
                    console.warn('Invalid response format from relations API');
                    setRelations([]);
                }
                setRelationsLoading(false);
            } catch (error) {
                console.error("Error fetching relations:", error);
                // Fallback to empty array if API fails
                setRelations([]);
                setRelationsLoading(false);
            }
        };

        fetchRelations();
    }, []);

    // Fetch marital statuses from HIMS API
    useEffect(() => {
        const fetchMaritalStatuses = async () => {
            try {
                setMaritalStatusesLoading(true);
                const response = await axios.get(
                    `${process.env.REACT_APP_KIOSK_OPS_URL}/lookup/master?categoryName=MARITALSTATUS`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('token')?.replace(/^"(.*)"$/, '$1')}`,
                        },
                    }
                );

                if (response.data && response.data.status === 'success' && Array.isArray(response.data.data)) {
                    setMaritalStatuses(response.data.data);
                } else {
                    console.warn('Invalid response format from marital status API');
                    setMaritalStatuses([]);
                }
                setMaritalStatusesLoading(false);
            } catch (error) {
                console.error("Error fetching marital statuses:", error);
                // Fallback to empty array if API fails
                setMaritalStatuses([]);
                setMaritalStatusesLoading(false);
            }
        };

        fetchMaritalStatuses();
    }, []);

    // Fetch countries from HIMS API
    useEffect(() => {
        const fetchCountries = async () => {
            try {
                setCountriesLoading(true);
                const response = await axios.get(
                    `${process.env.REACT_APP_KIOSK_OPS_URL}/address/address/country`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('token')?.replace(/^"(.*)"$/, '$1')}`,
                        },
                    }
                );

                if (response.data && response.data.status === 'success' && Array.isArray(response.data.data)) {
                    setCountries(response.data.data);

                    // Find and set India as default country
                    const india = response.data.data.find(c => c.countryName.toUpperCase() === 'INDIA');
                    if (india) {
                        setFormData(prev => ({ ...prev, country: india.countryId.toString() }));
                        setCountrySearch('INDIA');

                        // Fetch states for India
                        fetchStatesAndSetOdisha(india.countryId);
                    }
                } else {
                    console.error('Invalid countries data format:', response.data);
                    setCountries([]);
                }
                setCountriesLoading(false);
            } catch (error) {
                console.error('Error fetching countries:', error);
                setCountries([]);
                setCountriesLoading(false);
            }
        };

        // Function to fetch states and set Odisha as default, then set district and city
        const fetchStatesAndSetOdisha = async (countryId) => {
            try {
                setStatesLoading(true);
                const response = await axios.get(
                    `${process.env.REACT_APP_KIOSK_OPS_URL}/address/address/state?countryId=${countryId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('token')?.replace(/^"(.*)"$/, '$1')}`,
                        },
                    }
                );

                if (response.data && response.data.status === 'success' && Array.isArray(response.data.data)) {
                    setStates(response.data.data);

                    // Find and set Odisha as default state
                    const odisha = response.data.data.find(s => s.stateName.toUpperCase() === 'ODISHA');
                    if (odisha) {
                        setFormData(prev => ({ ...prev, state: odisha.stateId.toString() }));
                        setStateSearch('ODISHA');

                        // Fetch districts for Odisha and set KHORDA as default
                        const districtResponse = await axios.get(
                            `${process.env.REACT_APP_KIOSK_OPS_URL}/address/address/district?stateId=${odisha.stateId}`,
                            {
                                headers: {
                                    Authorization: `Bearer ${localStorage.getItem('token')?.replace(/^"(.*)"$/, '$1')}`,
                                },
                            }
                        );

                        if (districtResponse.data && districtResponse.data.status === 'success' && Array.isArray(districtResponse.data.data)) {
                            setDistricts(districtResponse.data.data);

                            // Find KHORDA and set as default
                            const KHORDA = districtResponse.data.data.find(district => district.districtName.toUpperCase() === 'KHORDA');
                            if (KHORDA) {
                                setFormData(prev => ({ ...prev, district: KHORDA.districtId.toString() }));
                                setDistrictSearch('KHORDA');

                                // Fetch cities for KHORDA and set BHUBANESWAR as default
                                const cityResponse = await axios.get(
                                    `${process.env.REACT_APP_KIOSK_OPS_URL}/address/address/city?stateId=${odisha.stateId}&districtId=${KHORDA.districtId}`,
                                    {
                                        headers: {
                                            Authorization: `Bearer ${localStorage.getItem('token')?.replace(/^"(.*)"$/, '$1')}`,
                                        },
                                    }
                                );

                                if (cityResponse.data && cityResponse.data.status === 'success' && Array.isArray(cityResponse.data.data)) {
                                    setCities(cityResponse.data.data);

                                    // Find BHUBANESWAR and set as default
                                    const bhubaneswar = cityResponse.data.data.find(city => city.cityName.toUpperCase() === 'BHUBANESWAR');
                                    if (bhubaneswar) {
                                        setFormData(prev => ({ ...prev, city: bhubaneswar.cityId.toString() }));
                                        setCitySearch('BHUBANESWAR');
                                    }
                                }
                            }
                        }
                    }
                }
                setStatesLoading(false);
            } catch (error) {
                console.error('Error fetching states for default:', error);
                setStatesLoading(false);
            }
        };

        fetchCountries();
    }, []);

    // Fetch states based on selected country
    const fetchStates = async (countryId) => {
        try {
            console.log('Fetching states for countryId:', countryId);
            setStatesLoading(true);
            setStates([]);
            const url = `${process.env.REACT_APP_KIOSK_OPS_URL}/address/address/state?countryId=${countryId}`;
            console.log('State API URL:', url);

            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')?.replace(/^"(.*)"$/, '$1')}`,
                },
            });

            console.log('State API Response:', response.data);

            if (response.data && response.data.status === 'success' && Array.isArray(response.data.data)) {
                console.log('States loaded:', response.data.data.length);
                setStates(response.data.data);
            } else {
                console.error('Invalid states data format:', response.data);
                setStates([]);
            }
            setStatesLoading(false);
        } catch (error) {
            console.error('Error fetching states:', error);
            console.error('Error details:', error.response?.data);
            setStates([]);
            setStatesLoading(false);
        }
    };

    // Fetch districts based on selected state
    const fetchDistricts = async (stateId) => {
        try {
            setDistrictsLoading(true);
            setDistricts([]);
            const response = await axios.get(
                `${process.env.REACT_APP_KIOSK_OPS_URL}/address/address/district?stateId=${stateId}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')?.replace(/^"(.*)"$/, '$1')}`,
                    },
                }
            );

            if (response.data && response.data.status === 'success' && Array.isArray(response.data.data)) {
                setDistricts(response.data.data);
            } else {
                console.error('Invalid districts data format:', response.data);
                setDistricts([]);
            }
            setDistrictsLoading(false);
        } catch (error) {
            console.error('Error fetching districts:', error);
            setDistricts([]);
            setDistrictsLoading(false);
        }
    };

    // Fetch cities based on selected state and district
    const fetchCities = async (stateId, districtId) => {
        try {
            setCitiesLoading(true);
            setCities([]);
            const response = await axios.get(
                `${process.env.REACT_APP_KIOSK_OPS_URL}/address/address/city?stateId=${stateId}&districtId=${districtId}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')?.replace(/^"(.*)"$/, '$1')}`,
                    },
                }
            );

            if (response.data && response.data.status === 'success' && Array.isArray(response.data.data)) {
                setCities(response.data.data);
            } else {
                console.error('Invalid cities data format:', response.data);
                setCities([]);
            }
            setCitiesLoading(false);
        } catch (error) {
            console.error('Error fetching cities:', error);
            setCities([]);
            setCitiesLoading(false);
        }
    };

    // Handle selecting country from dropdown
    const handleSelectCountry = (country) => {
        setFormData(prev => ({ ...prev, country: country.countryId.toString() }));
        setCountrySearch(country.countryName);
        setShowCountryDropdown(false);
        setErrors(prev => ({ ...prev, country: '' }));

        // Fetch states and reset dependent fields
        fetchStates(country.countryId);
        setFormData(prev => ({ ...prev, state: '', district: '', city: '' }));
        setStateSearch('');
        setDistrictSearch('');
        setCitySearch('');
        setStates([]);
        setDistricts([]);
        setCities([]);
    };

    // Handle selecting state from dropdown
    const handleSelectState = (state) => {
        setFormData(prev => ({ ...prev, state: state.stateId.toString() }));
        setStateSearch(state.stateName);
        setShowStateDropdown(false);
        setErrors(prev => ({ ...prev, state: '' }));

        // Fetch districts and reset dependent fields
        fetchDistricts(state.stateId);
        setFormData(prev => ({ ...prev, district: '', city: '' }));
        setDistrictSearch('');
        setCitySearch('');
        setDistricts([]);
        setCities([]);
    };

    // Handle selecting district from dropdown
    const handleSelectDistrict = (district) => {
        setFormData(prev => ({ ...prev, district: district.districtId.toString() }));
        setDistrictSearch(district.districtName);
        setShowDistrictDropdown(false);
        setErrors(prev => ({ ...prev, district: '' }));

        // Fetch cities and reset dependent field
        fetchCities(formData.state, district.districtId);
        setFormData(prev => ({ ...prev, city: '' }));
        setCitySearch('');
        setCities([]);
    };

    // Handle selecting city from dropdown
    const handleSelectCity = (city) => {
        setFormData(prev => ({ ...prev, city: city.cityId.toString() }));
        setCitySearch(city.cityName);
        setShowCityDropdown(false);
        setErrors(prev => ({ ...prev, city: '' }));
    };

    // Filter functions for searchable dropdowns
    const filteredCountries = countries.filter(country =>
        country.countryName.toLowerCase().includes(countrySearch.toLowerCase())
    );

    const filteredStates = states.filter(state =>
        state.stateName.toLowerCase().includes(stateSearch.toLowerCase())
    );

    const filteredDistricts = districts.filter(district =>
        district.districtName.toLowerCase().includes(districtSearch.toLowerCase())
    );

    const filteredCities = cities.filter(city =>
        city.cityName.toLowerCase().includes(citySearch.toLowerCase())
    );

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        // Enforce numeric-only for pincode and limit to 6 digits
        if (id === 'pincode') {
            const sanitized = value.replace(/\D/g, '').slice(0, 6);
            let updatedFormData = { ...formData, [id]: sanitized };
            let updatedErrors = { ...errors, [id]: '' };
            setFormData(updatedFormData);
            setErrors(updatedErrors);
            return;
        }

        let updatedFormData = { ...formData, [id]: value };
        let updatedErrors = { ...errors, [id]: '' };

        // Auto-select gender based on prefix genderId
        if (id === 'prefix' && value) {
            const selectedPrefix = prefixes.find(p => p.id === parseInt(value));
            if (selectedPrefix && selectedPrefix.genderId) {
                const genderId = selectedPrefix.genderId;
                if (genderId === 1) {
                    setSelectedGender('male');
                    updatedFormData.gender = 1;
                    updatedFormData.genderCode = 'M';
                    updatedErrors.gender = '';
                } else if (genderId === 2) {
                    setSelectedGender('female');
                    updatedFormData.gender = 2;
                    updatedFormData.genderCode = 'F';
                    updatedErrors.gender = '';
                }
                // If genderId is empty/null, don't auto-select, let user choose
            }
        }

        if (id === 'dob' && value) {
            // Calculate age and age type
            const dobDate = new Date(value);
            const today = new Date();
            let age = today.getFullYear() - dobDate.getFullYear();
            const m = today.getMonth() - dobDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < dobDate.getDate())) {
                age--;
            }
            // Decide age type
            let ageType = 'year';
            if (age === 0) {
                // Less than 1 year, calculate months or days
                const months = (today.getFullYear() - dobDate.getFullYear()) * 12 + (today.getMonth() - dobDate.getMonth());
                if (months === 0) {
                    // Less than 1 month, use days
                    const days = Math.floor((today - dobDate) / (1000 * 60 * 60 * 24));
                    updatedFormData.age = days;
                    ageType = 'day';
                } else {
                    updatedFormData.age = months;
                    ageType = 'month';
                }
            } else {
                updatedFormData.age = age;
                ageType = 'year';
            }
            updatedFormData.ageSelect = ageType;
        }

        if (id === 'age' && value) {
            // Only update DOB if age is a valid number and ageSelect is set
            const ageNum = parseInt(value, 10);
            if (!isNaN(ageNum) && ageNum > 0) {
                let year = new Date().getFullYear();
                let month = 5; // June (0-based)
                let day = 1;
                if (formData.ageSelect === 'year') {
                    year = year - ageNum;
                } else if (formData.ageSelect === 'month') {
                    // Subtract months from current date
                    const d = new Date();
                    d.setMonth(d.getMonth() - ageNum);
                    year = d.getFullYear();
                    month = d.getMonth();
                } else if (formData.ageSelect === 'day') {
                    // Subtract days from current date
                    const d = new Date();
                    d.setDate(d.getDate() - ageNum);
                    year = d.getFullYear();
                    month = d.getMonth();
                    day = d.getDate();
                }
                // Format as yyyy-mm-dd
                const mm = String(month + 1).padStart(2, '0');
                const dd = String(day).padStart(2, '0');
                updatedFormData.dob = `${year}-${mm}-${dd}`;
            }
        }

        if (id === 'ageSelect' && formData.age) {
            // When age type changes, recalculate DOB
            const ageNum = parseInt(formData.age, 10);
            if (!isNaN(ageNum) && ageNum > 0) {
                let year = new Date().getFullYear();
                let month = 5; // June (0-based)
                let day = 1;
                if (value === 'year') {
                    year = year - ageNum;
                } else if (value === 'month') {
                    const d = new Date();
                    d.setMonth(d.getMonth() - ageNum);
                    year = d.getFullYear();
                    month = d.getMonth();
                } else if (value === 'day') {
                    const d = new Date();
                    d.setDate(d.getDate() - ageNum);
                    year = d.getFullYear();
                    month = d.getMonth();
                    day = d.getDate();
                }
                const mm = String(month + 1).padStart(2, '0');
                const dd = String(day).padStart(2, '0');
                updatedFormData.dob = `${year}-${mm}-${dd}`;
            }
        }

        // Handle dependent address dropdowns
        if (id === 'country' && value) {
            console.log('Country selected:', value);
            fetchStates(value);
            // Reset dependent fields
            updatedFormData.state = '';
            updatedFormData.district = '';
            updatedFormData.city = '';
            setStates([]);
            setDistricts([]);
            setCities([]);
        }

        if (id === 'state' && value) {
            console.log('State selected:', value);
            fetchDistricts(value);
            // Reset dependent fields
            updatedFormData.district = '';
            updatedFormData.city = '';
            setDistricts([]);
            setCities([]);
        }

        if (id === 'district' && value) {
            console.log('District selected:', value);
            fetchCities(formData.state, value);
            // Reset dependent field
            updatedFormData.city = '';
            setCities([]);
        }

        setFormData(updatedFormData);
        setErrors(updatedErrors);
    };

    const handleGenderChange = (e) => {
        const gender = e.target.value;
        setSelectedGender(gender);
        setFormData((prev) => ({
            ...prev,
            gender: gender === 'male' ? 1 : gender === 'female' ? 2 : 3,
            genderCode: gender === 'male' ? 'M' : gender === 'female' ? 'F' : 'O',
        }));
        setErrors((prev) => ({ ...prev, gender: '' }));
    };

    const handleAreaChange = (e) => {
        const area = e.target.value;
        setSelectedArea(area);
        setFormData((prev) => ({ ...prev, area }));
        setErrors((prev) => ({ ...prev, area: '' }));
    };

    const handleCopyToWhatsapp = (e) => {
        const isChecked = e.target.checked;
        setCopyToWhatsapp(isChecked);
        if (isChecked && formData.mobileNumber) {
            setFormData((prev) => ({ ...prev, whatsappNumber: formData.mobileNumber }));
        } else if (!isChecked) {
            setFormData((prev) => ({ ...prev, whatsappNumber: '' }));
        }
    };

    // Check if mobile number already exists
    const checkMobileNumber = async (mobileNumber) => {
        // Only check if mobile number is 10 digits
        if (!/^\d{10}$/.test(mobileNumber)) {
            return;
        }

        setLoading(true);
        setErrors((prev) => ({ ...prev, mobileNumber: '' }));

        try {
            // Updated to use external API
            const response = await axios.get(
                `${process.env.REACT_APP_KIOSK_OPS_URL}/patient/registeredPatientDetails?input=${mobileNumber}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')?.replace(/^"(.*)"$/, '$1')}`,
                    },
                }
            );

            if (response.data && response.data.status === 'success' && response.data.data && response.data.data.length > 0) {
                const patientCount = response.data.data.length;

                // Extract unique names to avoid duplicates in the list if any
                const uniqueNames = [...new Set(response.data.data.map(p => p.patientName))];

                const patientNames = uniqueNames.join(', ');

                setDialogMessage(
                    `This mobile number is already registered with ${patientCount} patient${patientCount > 1 ? 's' : ''}: ${patientNames}. Do you want to create a new registration with this mobile number?`
                );
                setDialogMobile(mobileNumber);
                setShowAlreadyRegisteredDialog(true);
            }
        } catch (error) {
            console.error('Error checking mobile number:', error);
            // Don't show error to user, just log it
        } finally {
            setLoading(false);
        }
    };

    const validateForm = () => {
        let formErrors = {};
        const requiredFields = [
            'prefix', 'firstName', 'lastName', 'dob', 'age', 'mobileNumber',
            'city', 'district', 'state', 'country', 'emergencyContactNo',
            'emergencyContactName', 'relation', 'whatsappNumber'
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                formErrors[field] = `${field.replace(/([A-Z])/g, ' $1').toLowerCase()} is required`;
            }
        });
        if (!selectedGender) formErrors.gender = 'Gender is required';
        if (!selectedArea) formErrors.area = 'Area is required';
        // if (selectedArea === 'urban' && !formData.house) {
        //     formErrors.house = 'House number is required';
        // }
        if (selectedArea === 'rural' && !formData.village) {
            formErrors.village = 'Village name is required';
        }
        if (selectedArea === 'international') {
            if (!formData.passportNo) formErrors.passportNo = 'Passport number is required';
            if (!formData.visaNo) formErrors.visaNo = 'Visa number is required';
        }
        if (formData.mobileNumber && !/^\d{10}$/.test(formData.mobileNumber)) {
            formErrors.mobileNumber = 'Mobile number must be 10 digits';
        }
        if (formData.emergencyContactNo && !/^\d{10}$/.test(formData.emergencyContactNo)) {
            formErrors.emergencyContactNo = 'Emergency contact number must be 10 digits';
        }
        if (formData.aadharNumber && !/^\d{12}$/.test(formData.aadharNumber)) {
            formErrors.aadharNumber = 'Aadhar number must be 12 digits';
        }
        if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            formErrors.email = 'Invalid email format';
        }
        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
    };

    // Open Camera Modal
    const openCamera = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    width: { ideal: 640 },
                    height: { ideal: 480 }
                }
            });
            setShowCameraModal(true);
            setTimeout(() => {
                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                    streamRef.current = stream;
                }
            }, 100);
        } catch (error) {
            console.error('Camera access error:', error);
            alert('Unable to access camera. Please check camera permissions.');
        }
    };

    // Close Camera Modal
    const closeCamera = () => {
        if (streamRef.current) {
            streamRef.current.getTracks().forEach(track => track.stop());
            streamRef.current = null;
        }
        setShowCameraModal(false);
    };

    // Capture Photo
    const capturePhoto = () => {
        if (videoRef.current && canvasRef.current) {
            const video = videoRef.current;
            const canvas = canvasRef.current;
            const context = canvas.getContext('2d');

            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            context.drawImage(video, 0, 0, canvas.width, canvas.height);

            const base64Image = canvas.toDataURL('image/jpeg', 0.8);
            console.log('Image captured, length:', base64Image.length);
            setCapturedImage(base64Image);
            closeCamera();
        }
    };

    // Retake Photo
    const retakePhoto = () => {
        setCapturedImage(null);
    };

    // Submit → Register → Show OTP or Already Registered Dialog
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        setLoading(true);
        setErrors({});

        try {
            // Find selected relation from relations array
            const selectedRelation = relations.find((r) => r.lookupId === parseInt(formData.relation));

            // Find selected marital status from maritalStatuses array
            const selectedMaritalStatus = maritalStatuses.find((m) => m.lookupId === parseInt(formData.maritalStatus));

            // Find selected country, state, district, city
            const selectedCountry = countries.find(c => c.countryId === parseInt(formData.country));
            const selectedState = states.find(s => s.stateId === parseInt(formData.state));
            const selectedDistrict = districts.find(d => d.districtId === parseInt(formData.district));
            const selectedCity = cities.find(c => c.cityId === parseInt(formData.city));

            const payload = {
                firstName: formData.firstName,
                middleName: formData.middleName,
                lastName: formData.lastName,
                gender: formData.gender,
                genderCode: formData.genderCode,
                nationality: selectedCountry?.countryName || '',
                emailAddress: formData.email,
                contactNumber: formData.mobileNumber,
                whatsappNumber: formData.whatsappNumber,
                address: `${formData.locality || ''}, ${formData.village || formData.house || ''}`.trim(),
                state: selectedState?.stateName || '',
                city: selectedCity?.cityName || '',
                siteId: 2468,
                age: parseInt(formData.age),
                dob: formData.dob,
                pinCode: formData.pincode,
                relation: selectedRelation?.lookupValue || '',
                relationCode: parseInt(formData.relation),
                prefixName: parseInt(formData.prefix),
                prefix: prefixes.find((p) => p.id === parseInt(formData.prefix))?.prefix_name || formData.prefix,
                agree: true,
                receiveCall: true,
                base64String: capturedImage || imageData || '',
                siteCode: 'PBMH',
                maritalStatus: parseInt(formData.maritalStatus) || null,
                maritialStatusCode: selectedMaritalStatus?.lookupCode || '',
                emergencyContactNo: formData.emergencyContactNo,
                emergencyContactName: formData.emergencyContactName,
                locality: formData.locality || '',
                aadhaarCardNo: formData.aadharNumber || '',
                // NEW: Add ID fields
                countryId: parseInt(formData.country) || null,
                stateId: parseInt(formData.state) || null,
                districtId: parseInt(formData.district) || null,
                cityId: parseInt(formData.city) || null,
                // NEW: Add name fields
                countryName: selectedCountry?.countryName || '',
                stateName: selectedState?.stateName || '',
                districtName: selectedDistrict?.districtName || '',
                cityName: selectedCity?.cityName || '',
                addressList: [{
                    address: `${formData.village || formData.house || ''}`.trim(),
                    postOffice: formData.postOffice,
                    streetvillage: formData.village || formData.house,
                    policeStation: formData.policeStation,
                    city: parseInt(formData.city) || 1,
                    district: selectedDistrict?.districtName || '',
                    postalCode: formData.pincode,
                }],
                isUrban: selectedArea === 'urban' ? true : false,
                consentConfirmation: formData.consentConfirmation || false,
            };

            console.log('Submitting with image:', {
                hasCapturedImage: !!capturedImage,
                hasImageData: !!imageData,
                imageLength: (capturedImage || imageData || '').length
            });

            const patientResponse = await axiosInstance.post('/api/patient/new-registration', payload);

            if (patientResponse.status === 201) {
                setPatientMrno(patientResponse.data.mrno);
                setPatientId(patientResponse.data.patientId);
                setShowOTPScreen(true);
                setLoading(false);
                window.scrollTo(0, 0);
            }
        } catch (error) {
            const errMsg = error.response?.data?.errors?.mobile || error.message || 'Failed to register patient';
            setErrors({ general: errMsg });
            setLoading(false);
        }
    };

    // Handle "Yes" - Continue with same mobile number
    const handleCreateNewRegistration = () => {
        setShowAlreadyRegisteredDialog(false);
        // Mobile number remains in form, user can continue filling the form
    };

    // Handle "No" - Clear mobile number and focus on input
    const handleNavigateToLogin = () => {
        setShowAlreadyRegisteredDialog(false);
        setFormData(prev => ({ ...prev, mobileNumber: '' }));
        setErrors(prev => ({ ...prev, mobileNumber: '' }));
        // Focus on mobile number input
        setTimeout(() => {
            const mobileInput = document.getElementById('mobileNumber');
            if (mobileInput) {
                mobileInput.focus();
            }
        }, 100);
    };

    // Verify OTP
    const verifyOTP = async () => {
        if (otp.length !== 6) {
            setOtpError('Enter 6-digit OTP');
            return;
        }
        setOtpLoading(true);
        setOtpError('');

        try {
            const res = await axiosInstance.post('/api/patient/verify-otp', {
                patientId,
                otp: otp.trim()
            });

            if (res.data.success) {
                setShowOTPScreen(false);
                await handleRegistrationPayment(patientMrno);
            }
        } catch (error) {
            setOtpError(error.response?.data?.errors?.otp || 'Invalid or expired OTP');
        } finally {
            setOtpLoading(false);
        }
    };

    // Resend OTP
    const resendOTP = async () => {
        setOtpLoading(true);
        setOtpError('');

        try {
            await axiosInstance.post('/api/patient/new-registration', {
                contactNumber: formData.mobileNumber,
                firstName: formData.firstName || 'Temp',
                middleName: formData.middleName || '',
                lastName: formData.lastName || 'User',
                siteId: 2468,
                siteCode: 'PBMH',
                isResend: true
            });

            setOtp('');
            setOtpError('OTP resent successfully!');
            setTimeout(() => setOtpError(''), 3000);
        } catch (error) {
            setOtpError(error.response?.data?.errors?.general || 'Failed to resend');
        } finally {
            setOtpLoading(false);
        }
    };

    // Registration Payment (Fixed 100 Rupees)
    const handleRegistrationPayment = async (mrno) => {
        try {
            const { data } = await axiosInstance.post('/api/patient/create-registration-order', {
                patientMrno: mrno,
                siteCode: 'PBMH',
            });

            const form = document.createElement('form');
            form.method = 'POST';
            form.action = 'https://api.razorpay.com/v1/checkout/embedded';

            const formFields = {
                key_id: data.key,
                amount: data.amount.toString(),
                currency: data.currency,
                name: "KIMS",
                description: "Patient Registration Fee",
                image: "/logo.jpg",
                order_id: data.order_id,
                callback_url: `${axiosInstance.defaults.baseURL}/api/patient/verify-payment`,
                cancel_url: `${axiosInstance.defaults.baseURL}/api/patient/cancel-payment`,
                prefill: {
                    name: `${formData.firstName || ''}  ${formData.middleName || ''} ${formData.lastName || ''}`.trim() || 'test test',
                    email: formData.email || 'test@gmail.com',
                    contact: formData.mobileNumber || '9427388748',
                },
                theme: { color: "#0FA968" },
            };

            Object.keys(formFields).forEach((key) => {
                if (typeof formFields[key] === 'object') {
                    Object.keys(formFields[key]).forEach((subKey) => {
                        const input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = `${key}[${subKey}]`;
                        input.value = formFields[key][subKey];
                        form.appendChild(input);
                    });
                } else {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = formFields[key];
                    form.appendChild(input);
                }
            });

            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        } catch (error) {
            console.error('Registration payment error:', error);
            setLoading(false);
        }
    };

    // Already Registered Dialog Render
    const renderAlreadyRegisteredDialog = () => {
        if (!showAlreadyRegisteredDialog) return null;

        return (
            <div className="fixed inset-0 z-50 flex justify-center items-center w-full h-full bg-black bg-opacity-50 px-4">
                <div className="relative p-6 sm:p-8 w-full max-w-md bg-white rounded-2xl shadow-2xl">
                    <div className="text-center">
                        <div className="w-20 h-20 mx-auto mb-4 bg-yellow-100 rounded-full flex items-center justify-center">
                            <svg className="w-12 h-12 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                            </svg>
                        </div>
                        <h3 className="text-2xl font-bold text-[#22292A] mb-4">
                            Patient Already Registered
                        </h3>
                        <p className="text-gray-600 text-lg leading-relaxed mb-4">
                            {dialogMessage}
                        </p>
                        <div className="bg-blue-50 rounded-lg p-4 mb-6">
                            <p className="text-sm text-gray-700">
                                <strong>Mobile Number:</strong> {dialogMobile}
                            </p>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                            <button
                                onClick={handleNavigateToLogin}
                                className="flex-1 bg-[#0FA968] text-white py-3 px-6 rounded-lg font-semibold hover:bg-[#138F5E] transition duration-200"
                            >
                                No
                            </button>
                            <button
                                onClick={handleCreateNewRegistration}
                                disabled={loading}
                                className={`flex-1 bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 transition duration-200 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                            >
                                {loading ? (
                                    <div className="w-6 h-6 mx-auto border-4 border-white border-t-transparent rounded-full animate-spin"></div>
                                ) : (
                                    'Yes'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    // OTP SCREEN RENDER
    const renderOTPScreen = () => {
        if (!showOTPScreen) return null;

        return (
            <div className="fixed inset-0 z-50 flex justify-center items-center w-full h-full bg-[#03301F] bg-opacity-50 px-4">
                <div className="relative p-5 sm:p-6 w-full max-w-md bg-white rounded-2xl shadow-2xl">
                    <button
                        onClick={() => setShowOTPScreen(false)}
                        className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>

                    <div className="text-center">
                        <div className="w-20 h-20 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center">
                            <svg className="w-12 h-12 text-[#0FA968]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                            </svg>
                        </div>
                        <h3 className="text-2xl font-bold text-[#22292A] mb-2">Verify Mobile Number</h3>
                        We sent a 6-digit OTP to <br />
                        <span className="font-semibold">+91 {formData.mobileNumber}</span>

                        <div className="mb-4">
                            <input
                                type="text"
                                maxLength="6"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
                                className="w-full px-4 py-3 text-center text-2xl font-mono tracking-widest border-2 border-[#B9B9C0] rounded-lg focus:border-[#0FA968] focus:outline-none"
                                placeholder="000000"
                            />
                            {otpError && <p className="text-red-500 text-sm mt-2">{otpError}</p>}
                        </div>

                        <button
                            onClick={verifyOTP}
                            disabled={otpLoading || otp.length !== 6}
                            className={`w-full py-3 mb-3 text-white font-semibold rounded-lg transition ${otpLoading || otp.length !== 6
                                ? 'bg-gray-400 cursor-not-allowed'
                                : 'bg-[#0FA968] hover:bg-[#138F5E]'
                                }`}
                        >
                            {otpLoading ? (
                                <div className="w-6 h-6 mx-auto border-4 border-white border-t-transparent rounded-full animate-spin"></div>
                            ) : (
                                'Verify & Pay ₹100'
                            )}
                        </button>

                        <div className="text-center">
                            <p className="text-sm text-gray-600">
                                Didn't receive?{' '}
                                <button
                                    onClick={resendOTP}
                                    disabled={otpLoading}
                                    className="font-semibold text-[#0FA968] hover:underline"
                                >
                                    Resend OTP
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="page-container flex flex-col min-h-screen">
            <div className="form-container flex-grow overflow-auto overflow-x-hidden">
                <StepOne />
                <div className="px-4 sm:px-8 lg:px-14 mt-4 sm:mt-6 max-w-[1600px] mx-auto w-full">
                    <form onSubmit={handleSubmit}>
                        {errors.general && <p className="text-red-500 text-sm mb-4">{errors.general}</p>}
                        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-[150px_1fr_2fr] gap-4 md:gap-6">
                            {/* <div className="flex flex-col items-center">
                                {imageData ? (
                                    <img src={imageData} alt="Patient" className="rounded-xl mb-6" style={{ height: '160px', width: '148px' }} />
                                ) : (
                                    <img src={UserImg} alt="Patient" className="rounded-xl p-2 mb-6 bg-[#d3d3d3]" style={{ height: '160px', width: '148px' }} />
                                )}
                            </div> */}
                            {/* Image capture section */}
                            <div className="flex flex-col items-center md:items-start xl:items-center">
                                {capturedImage || imageData ? (
                                    <img
                                        src={capturedImage || imageData}
                                        alt="Patient"
                                        className="rounded-xl mb-4 w-[120px] h-[130px] sm:w-[148px] sm:h-[160px] object-cover"
                                    />
                                ) : (
                                    <img
                                        src={UserImg}
                                        alt="Patient"
                                        className="rounded-xl p-2 mb-4 bg-[#d3d3d3] w-[120px] h-[130px] sm:w-[148px] sm:h-[160px] object-cover"
                                    />
                                )}
                                {/*<button
                                    type="button"
                                    onClick={capturedImage ? retakePhoto : openCamera}
                                    className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition duration-200"
                                    disabled
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                    {capturedImage ? 'Retake Photo' : 'Take Photo'}
                                </button>*/}
                            </div>
                            <div className="flex flex-col w-full">
                                <div className="flex flex-col mb-4 sm:mb-6">
                                    <label htmlFor="prefix" className="block mb-1 text-sm font-medium text-[#22292A]">
                                        Prefix <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        id="prefix"
                                        value={formData.prefix}
                                        onChange={handleInputChange}
                                        disabled={prefixesLoading}
                                        className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.prefix ? 'border-red-500' : 'border-[#B9B9C0]'} ${prefixesLoading ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                        aria-invalid={errors.prefix ? 'true' : 'false'}
                                        aria-describedby="prefix-error"
                                    >
                                        <option value="">{prefixesLoading ? 'Loading...' : 'Select'}</option>
                                        {prefixes.map((prefix) => (
                                            <option key={prefix.id} value={prefix.id}>{prefix.prefix_name}</option>
                                        ))}
                                    </select>
                                    {errors.prefix && <p id="prefix-error" className="text-red-500 text-sm">{errors.prefix}</p>}
                                </div>
                                <div className={`flex flex-col ${!errors.gender && 'mt-3'}`}>
                                    <label className="block mb-1 text-sm font-medium text-[#22292A]">
                                        Gender <span className="text-red-500">*</span>
                                    </label>
                                    <ul className="grid grid-cols-3 gap-2 sm:gap-4">
                                        {['male', 'female', 'other'].map((gender) => (
                                            <li key={gender}>
                                                <input type="radio" id={gender} name="gender" value={gender} checked={selectedGender === gender} onChange={handleGenderChange} className="hidden peer" />
                                                <label htmlFor={gender} className={`inline-flex items-center justify-center w-full p-2 text-center border rounded-lg cursor-pointer ${selectedGender === gender ? 'bg-green-600 text-white border-green-600' : 'bg-white text-gray-500'}`}>
                                                    <div className="text-sm sm:text-lg font-semibold capitalize">{gender}</div>
                                                </label>
                                            </li>
                                        ))}
                                    </ul>
                                    {errors.gender && <p id="gender-error" className="text-red-500 text-sm">{errors.gender}</p>}
                                </div>
                            </div>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 md:gap-x-6 gap-y-4 md:col-span-2 xl:col-span-1 w-full">
                                {['firstName', 'middleName', 'lastName'].map((field) => (
                                    <div key={field} className="mb-2 sm:mb-6">
                                        <label htmlFor={field} className="block mb-1 text-sm font-medium text-[#22292A] uppercase">
                                            {field.replace(/([A-Z])/g, ' $1').toLowerCase()} <span className={field === 'middleName' ? '' : 'text-red-500'}>{field === 'middleName' ? '' : '*'}</span>
                                        </label>
                                        <input type="text" id={field} value={formData[field]} onChange={handleInputChange} className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors[field] ? 'border-red-500' : 'border-[#B9B9C0]'}`} placeholder={field.replace(/([A-Z])/g, ' $1').toLowerCase()} aria-invalid={errors[field] ? 'true' : 'false'} aria-describedby={`${field}-error`} />
                                        {errors[field] && <p id={`${field}-error`} className="text-red-500 text-sm">{errors[field]}</p>}
                                    </div>
                                ))}
                                <div className="w-full">
                                    <label htmlFor="dob" className="block mb-1 text-sm font-medium text-[#22292A]">Date of Birth <span className="text-red-500">*</span></label>
                                    <input 
                                        type="date" 
                                        id="dob" 
                                        value={formData.dob} 
                                        onChange={handleInputChange} 
                                        max={new Date().toISOString().split('T')[0]}
                                        min={new Date(new Date().getFullYear() - 150, 0, 1).toISOString().split('T')[0]}
                                        className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.dob ? 'border-red-500' : 'border-[#B9B9C0]'}`} 
                                        aria-invalid={errors.dob ? 'true' : 'false'} 
                                        aria-describedby="dob-error" 
                                    />
                                    {errors.dob && <p id="dob-error" className="text-red-500 text-sm">{errors.dob}</p>}
                                </div>
                                <div className="grid grid-cols-2 gap-2 sm:gap-0 lg:ms-6">
                                    <div>
                                        <label htmlFor="age" className="block mb-1 text-sm font-medium text-[#22292A]">Age <span className="text-red-500">*</span></label>
                                        <input type="number" id="age" value={formData.age} onChange={handleInputChange} className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-l-lg ${errors.age ? 'border-red-500' : 'border-[#B9B9C0]'}`} aria-invalid={errors.age ? 'true' : 'false'} aria-describedby="age-error" />
                                        {errors.age && <p id="age-error" className="text-red-500 text-sm">{errors.age}</p>}
                                    </div>
                                    <div>
                                        <label htmlFor="ageSelect" className="block mb-1 text-sm font-medium text-[#22292A]">Select</label>
                                        <select id="ageSelect" value={formData.ageSelect} onChange={handleInputChange} className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-r-lg ${errors.ageSelect ? 'border-red-500' : 'border-[#B9B9C0]'}`} aria-invalid={errors.ageSelect ? 'true' : 'false'} aria-describedby="ageSelect-error">
                                            <option value="">Select</option>
                                            <option value="year">Year</option>
                                            <option value="month">Month</option>
                                            <option value="day">Day</option>
                                        </select>
                                        {errors.ageSelect && <p id="ageSelect-error" className="text-red-500 text-sm">{errors.ageSelect}</p>}
                                    </div>
                                </div>
                                <div className="lg:ms-6">
                                    <label htmlFor="mobileNumber" className="block mb-1 text-sm font-medium text-[#22292A]">Mobile Number <span className="text-red-500">*</span></label>
                                    <div className="relative">
                                        <input
                                            type="text"
                                            id="mobileNumber"
                                            value={formData.mobileNumber}
                                            onChange={e => {
                                                const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                                                handleInputChange({ target: { id: 'mobileNumber', value } });
                                                if (copyToWhatsapp) {
                                                    setFormData(prev => ({ ...prev, whatsappNumber: value }));
                                                }
                                            }}
                                            onBlur={() => checkMobileNumber(formData.mobileNumber)}
                                            className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.mobileNumber ? 'border-red-500' : 'border-[#B9B9C0]'}`}
                                            placeholder="Mobile Number"
                                            aria-invalid={errors.mobileNumber ? 'true' : 'false'}
                                            aria-describedby="mobileNumber-error"
                                            maxLength={10}
                                            pattern="[0-9]*"
                                            inputMode="numeric"
                                        />
                                        {loading && (
                                            <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-green-600"></div>
                                            </div>
                                        )}
                                    </div>
                                    {errors.mobileNumber && <p id="mobileNumber-error" className="text-red-500 text-sm">{errors.mobileNumber}</p>}
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-[150px_2fr_2fr_2fr] gap-4 md:gap-6 mt-4 md:mt-6">
                            <div className="hidden xl:block" />
                            <div className="flex flex-col">
                                <label htmlFor="whatsappNumber" className="block mb-1 text-sm font-medium text-[#22292A]">Whatsapp Number <span className="text-red-500">*</span></label>
                                <input
                                    type="text"
                                    id="whatsappNumber"
                                    value={formData.whatsappNumber}
                                    onChange={e => {
                                        const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10); handleInputChange({ target: { id: 'whatsappNumber', value } });
                                    }} className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.whatsappNumber ? 'border-red-500' : 'border-[#B9B9C0]'}`} placeholder="Whatsapp number" aria-invalid={errors.whatsappNumber ? 'true' : 'false'} aria-describedby="whatsappNumber-error" maxLength={10} pattern="[0-9]*" inputMode="numeric" />
                                <div className="flex items-center mt-2">
                                    <input
                                        type="checkbox"
                                        id="copyToWhatsapp"
                                        checked={copyToWhatsapp}
                                        onChange={handleCopyToWhatsapp}
                                        className="w-4 h-4 text-[#0FA968] bg-gray-100 border-gray-300 rounded focus:ring-[#0FA968] focus:ring-2"
                                    />
                                    <label htmlFor="copyToWhatsapp" className="ml-2 text-sm font-medium text-[#22292A]">
                                        Same as Mobile Number
                                    </label>
                                </div>
                                {errors.whatsappNumber && <p id="whatsappNumber-error" className="text-red-500 text-sm">{errors.whatsappNumber}</p>}
                            </div>
                            <div className="flex flex-col">
                                <label htmlFor="aadharNumber" className="block mb-1 text-sm font-medium text-[#22292A]">Aadhar Number</label>
                                <input type="text" id="aadharNumber" value={formData.aadharNumber} onChange={handleInputChange} className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.aadharNumber ? 'border-red-500' : 'border-[#B9B9C0]'}`} placeholder="0000 0000 0000" aria-invalid={errors.aadharNumber ? 'true' : 'false'} aria-describedby="aadharNumber-error" maxLength={12} pattern="[0-9]*" inputMode="numeric" />
                                {errors.aadharNumber && <p id="aadharNumber-error" className="text-red-500 text-sm">{errors.aadharNumber}</p>}
                            </div>
                            <div className="flex flex-col">
                                <label htmlFor="email" className="block mb-1 text-sm font-medium text-[#22292A]">Email Address</label>
                                <input type="email" id="email" value={formData.email} onChange={handleInputChange} className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.email ? 'border-red-500' : 'border-[#B9B9C0]'}`} placeholder="Email address" aria-invalid={errors.email ? 'true' : 'false'} aria-describedby="email-error" />
                                {errors.email && <p id="email-error" className="text-red-500 text-sm">{errors.email}</p>}
                            </div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-[150px_2fr_2fr_2fr] gap-4 md:gap-6 mt-4 md:mt-6">
                            <div className="hidden xl:block" />
                            <div className="flex flex-col">
                                <label htmlFor="emergencyContactName" className="block mb-1 text-sm font-medium text-[#22292A]">Emergency Contact Name <span className="text-red-500">*</span></label>
                                <input type="text" id="emergencyContactName" value={formData.emergencyContactName} onChange={handleInputChange} className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.emergencyContactName ? 'border-red-500' : 'border-[#B9B9C0]'}`} placeholder="Emergency Contact Name" aria-invalid={errors.emergencyContactName ? 'true' : 'false'} aria-describedby="emergencyContactName-error" />
                                {errors.emergencyContactName && <p id="emergencyContactName-error" className="text-red-500 text-sm">{errors.emergencyContactName}</p>}
                            </div>
                            <div className="flex flex-col">
                                <label htmlFor="emergencyContactNo" className="block mb-1 text-sm font-medium text-[#22292A]">Emergency Contact Number <span className="text-red-500">*</span></label>
                                <input type="text" id="emergencyContactNo" value={formData.emergencyContactNo} onChange={e => {
                                    const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                                    handleInputChange({ target: { id: 'emergencyContactNo', value } });
                                }} className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.emergencyContactNo ? 'border-red-500' : 'border-[#B9B9C0]'}`} placeholder="Emergency Contact Number" aria-invalid={errors.emergencyContactNo ? 'true' : 'false'} aria-describedby="emergencyContactNo-error" maxLength={10} pattern="[0-9]*" inputMode="numeric" />
                                {errors.emergencyContactNo && <p id="emergencyContactNo-error" className="text-red-500 text-sm">{errors.emergencyContactNo}</p>}
                            </div>
                            <div className="flex flex-col">
                                <label htmlFor="relation" className="block mb-1 text-sm font-medium text-[#22292A]">Relation <span className="text-red-500">*</span></label>
                                <select
                                    id="relation"
                                    value={formData.relation}
                                    onChange={handleInputChange}
                                    disabled={relationsLoading}
                                    className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.relation ? 'border-red-500' : 'border-[#B9B9C0]'} ${relationsLoading ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                    aria-invalid={errors.relation ? 'true' : 'false'}
                                    aria-describedby="relation-error"
                                >
                                    <option value="">{relationsLoading ? 'Loading...' : 'Select'}</option>
                                    {relations.map((relation) => (
                                        <option key={relation.lookupId} value={relation.lookupId}>
                                            {relation.lookupValue}
                                        </option>
                                    ))}
                                </select>
                                {errors.relation && <p id="relation-error" className="text-red-500 text-sm">{errors.relation}</p>}
                            </div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-[150px_2fr_2fr_2fr] gap-4 md:gap-6 mt-4 md:mt-6">
                            <div className="hidden xl:block" />
                            <div className="flex flex-col">
                                <label htmlFor="maritalStatus" className="block mb-1 text-sm font-medium text-[#22292A]">Marital Status</label>
                                <select
                                    id="maritalStatus"
                                    value={formData.maritalStatus}
                                    onChange={handleInputChange}
                                    disabled={maritalStatusesLoading}
                                    className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.maritalStatus ? 'border-red-500' : 'border-[#B9B9C0]'} ${maritalStatusesLoading ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                    aria-invalid={errors.maritalStatus ? 'true' : 'false'}
                                    aria-describedby="maritalStatus-error"
                                >
                                    <option value="">{maritalStatusesLoading ? 'Loading...' : 'Select'}</option>
                                    {maritalStatuses.map((status) => (
                                        <option key={status.lookupId} value={status.lookupId}>
                                            {status.lookupValue}
                                        </option>
                                    ))}
                                </select>
                                {errors.maritalStatus && <p id="maritalStatus-error" className="text-red-500 text-sm">{errors.maritalStatus}</p>}
                            </div>
                            <div className="hidden xl:block" /><div className="hidden xl:block" />
                        </div>
                        <hr className="mt-4 border-t-2 border-gray-300" />
                        <div>
                            <p className="text-[#757582] mt-4" style={{ fontFamily: 'Roboto', fontSize: '16px', fontWeight: '600', lineHeight: '18px' }}>
                                ADDRESS DETAILS
                            </p>
                        </div>
                        <div className="flex flex-col mt-6 mb-6">
                            <label className="block mb-1 text-sm font-medium text-[#22292A]">Area <span className="text-red-500">*</span></label>
                            <ul className="grid grid-cols-2 gap-4 max-w-xs sm:max-w-none">
                                <li>
                                    <input type="radio" id="urban" name="area" value="urban" checked={selectedArea === 'urban'} onChange={handleAreaChange} className="hidden peer" />
                                    <label htmlFor="urban" className={`inline-flex items-center justify-center w-full p-2 text-center border border-gray-200 rounded-lg cursor-pointer ${selectedArea === 'urban' ? 'bg-green-600 text-white border-green-600' : 'bg-white text-gray-500'}`}>
                                        <div className="block"><div className="text-sm sm:text-lg font-semibold">Urban</div></div>
                                    </label>
                                </li>
                                <li>
                                    <input type="radio" id="rural" name="area" value="rural" checked={selectedArea === 'rural'} onChange={handleAreaChange} className="hidden peer" />
                                    <label htmlFor="rural" className={`inline-flex items-center justify-center w-full p-2 text-center border border-gray-200 rounded-lg cursor-pointer ${selectedArea === 'rural' ? 'bg-green-600 text-white border-green-600' : 'bg-white text-gray-500'}`}>
                                        <div className="block"><div className="text-sm sm:text-lg font-semibold">Rural</div></div>
                                    </label>
                                </li>
                            </ul>
                            {errors.area && <p id="area-error" className="text-red-500 text-sm">{errors.area}</p>}
                        </div>
                        {selectedArea === 'international' && (
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                                <div>
                                    <label htmlFor="passportNo" className="block mb-1 text-sm font-medium text-[#22292A]">Passport No <span className="text-red-500">*</span></label>
                                    <input type="text" id="passportNo" value={formData.passportNo} onChange={handleInputChange} className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.passportNo ? 'border-red-500' : 'border-[#B9B9C0]'}`} placeholder="Passport No" aria-invalid={errors.passportNo ? 'true' : 'false'} aria-describedby="passportNo-error" />
                                    {errors.passportNo && <p id="passportNo-error" className="text-red-500 text-sm">{errors.passportNo}</p>}
                                </div>
                                <div>
                                    <label htmlFor="visaNo" className="block mb-1 text-sm font-medium text-[#22292A]">Visa No <span className="text-red-500">*</span></label>
                                    <input type="text" id="visaNo" value={formData.visaNo} onChange={handleInputChange} className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.visaNo ? 'border-red-500' : 'border-[#B9B9C0]'}`} placeholder="Visa No" aria-invalid={errors.visaNo ? 'true' : 'false'} aria-describedby="visaNo-error" />
                                    {errors.visaNo && <p id="visaNo-error" className="text-red-500 text-sm">{errors.visaNo}</p>}
                                </div>
                            </div>
                        )}
                        <div className="grid grid-cols-1 gap-y-4">
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
                                <div ref={countryRef} className="relative">
                                    <label htmlFor="country" className="block text-sm font-medium text-gray-700">Country <span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        value={countrySearch}
                                        onChange={(e) => {
                                            setCountrySearch(e.target.value);
                                            setShowCountryDropdown(true);
                                        }}
                                        onFocus={() => setShowCountryDropdown(true)}
                                        placeholder={countriesLoading ? 'Loading...' : 'Search Country'}
                                        disabled={countriesLoading}
                                        className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.country ? 'border-red-500' : 'border-[#B9B9C0]'} ${countriesLoading ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                        aria-invalid={errors.country ? 'true' : 'false'}
                                        aria-describedby="country-error"
                                    />
                                    {showCountryDropdown && !countriesLoading && filteredCountries.length > 0 && (
                                        <div className="absolute z-10 w-full mt-1 bg-white border-2 border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                                            {filteredCountries.map((country) => (
                                                <div
                                                    key={country.countryId}
                                                    onClick={() => handleSelectCountry(country)}
                                                    className="px-4 py-2 cursor-pointer hover:bg-[#DAFEEF] hover:text-[#0FA968] transition-colors"
                                                >
                                                    {country.countryName}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    {errors.country && <p id="country-error" className="text-red-500 text-sm">{errors.country}</p>}
                                </div>
                                <div ref={stateRef} className="relative">
                                    <label htmlFor="state" className="block text-sm font-medium text-gray-700">State <span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        value={stateSearch}
                                        onChange={(e) => {
                                            setStateSearch(e.target.value);
                                            setShowStateDropdown(true);
                                        }}
                                        onFocus={() => setShowStateDropdown(true)}
                                        placeholder={statesLoading ? 'Loading...' : !formData.country ? 'Select Country First' : 'Search State'}
                                        disabled={statesLoading || !formData.country}
                                        className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.state ? 'border-red-500' : 'border-[#B9B9C0]'} ${(statesLoading || !formData.country) ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                        aria-invalid={errors.state ? 'true' : 'false'}
                                        aria-describedby="state-error"
                                    />
                                    {showStateDropdown && !statesLoading && formData.country && filteredStates.length > 0 && (
                                        <div className="absolute z-10 w-full mt-1 bg-white border-2 border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                                            {filteredStates.map((state) => (
                                                <div
                                                    key={state.stateId}
                                                    onClick={() => handleSelectState(state)}
                                                    className="px-4 py-2 cursor-pointer hover:bg-[#DAFEEF] hover:text-[#0FA968] transition-colors"
                                                >
                                                    {state.stateName}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    {errors.state && <p id="state-error" className="text-red-500 text-sm">{errors.state}</p>}
                                </div>
                                <div ref={districtRef} className="relative">
                                    <label htmlFor="district" className="block text-sm font-medium text-gray-700">District <span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        value={districtSearch}
                                        onChange={(e) => {
                                            setDistrictSearch(e.target.value);
                                            setShowDistrictDropdown(true);
                                        }}
                                        onFocus={() => setShowDistrictDropdown(true)}
                                        placeholder={districtsLoading ? 'Loading...' : !formData.state ? 'Select State First' : 'Search District'}
                                        disabled={districtsLoading || !formData.state}
                                        className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.district ? 'border-red-500' : 'border-[#B9B9C0]'} ${(districtsLoading || !formData.state) ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                        aria-invalid={errors.district ? 'true' : 'false'}
                                        aria-describedby="district-error"
                                    />
                                    {showDistrictDropdown && !districtsLoading && formData.state && filteredDistricts.length > 0 && (
                                        <div className="absolute z-10 w-full mt-1 bg-white border-2 border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                                            {filteredDistricts.map((district) => (
                                                <div
                                                    key={district.districtId}
                                                    onClick={() => handleSelectDistrict(district)}
                                                    className="px-4 py-2 cursor-pointer hover:bg-[#DAFEEF] hover:text-[#0FA968] transition-colors"
                                                >
                                                    {district.districtName}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    {errors.district && <p id="district-error" className="text-red-500 text-sm">{errors.district}</p>}
                                </div>
                                <div ref={cityRef} className="relative">
                                    <label htmlFor="city" className="block text-sm font-medium text-gray-700">City <span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        value={citySearch}
                                        onChange={(e) => {
                                            setCitySearch(e.target.value);
                                            setShowCityDropdown(true);
                                        }}
                                        onFocus={() => setShowCityDropdown(true)}
                                        placeholder={citiesLoading ? 'Loading...' : !formData.district ? 'Select District First' : 'Search City'}
                                        disabled={citiesLoading || !formData.district}
                                        className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.city ? 'border-red-500' : 'border-[#B9B9C0]'} ${(citiesLoading || !formData.district) ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                        aria-invalid={errors.city ? 'true' : 'false'}
                                        aria-describedby="city-error"
                                    />
                                    {showCityDropdown && !citiesLoading && formData.district && filteredCities.length > 0 && (
                                        <div className="absolute z-10 w-full mt-1 bg-white border-2 border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                                            {filteredCities.map((city) => (
                                                <div
                                                    key={city.cityId}
                                                    onClick={() => handleSelectCity(city)}
                                                    className="px-4 py-2 cursor-pointer hover:bg-[#DAFEEF] hover:text-[#0FA968] transition-colors"
                                                >
                                                    {city.cityName}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    {errors.city && <p id="city-error" className="text-red-500 text-sm">{errors.city}</p>}
                                </div>
                                <div>
                                    <label htmlFor="pincode" className="block text-sm font-medium text-gray-700">Pincode</label>
                                        <input
                                            type="text"
                                            id="pincode"
                                            value={formData.pincode}
                                            onChange={handleInputChange}
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            maxLength={6}
                                            className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.pincode ? 'border-red-500' : 'border-[#B9B9C0]'}`}
                                            placeholder="Pin code"
                                            aria-invalid={errors.pincode ? 'true' : 'false'}
                                            aria-describedby="pincode-error"
                                        />
                                    {errors.pincode && <p id="pincode-error" className="text-red-500 text-sm">{errors.pincode}</p>}
                                </div>
                            </div>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
                                {selectedArea === 'urban' && (
                                    <div>
                                        <label htmlFor="house" className="block mb-1 text-sm font-medium text-[#22292A]">House No./PO</label>
                                        <input type="text" id="house" value={formData.house} onChange={handleInputChange} className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.house ? 'border-red-500' : 'border-[#B9B9C0]'}`} placeholder="House No" aria-invalid={errors.house ? 'true' : 'false'} aria-describedby="house-error" />
                                        {errors.house && <p id="house-error" className="text-red-500 text-sm">{errors.house}</p>}
                                    </div>
                                )}
                                {selectedArea === 'rural' && (
                                    <div>
                                        <label htmlFor="village" className="block mb-1 text-sm font-medium text-[#22292A]">Village Name <span className="text-red-500">*</span></label>
                                        <input type="text" id="village" value={formData.village} onChange={handleInputChange} className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.village ? 'border-red-500' : 'border-[#B9B9C0]'}`} placeholder="Village Name" aria-invalid={errors.village ? 'true' : 'false'} aria-describedby="village-error" />
                                        {errors.village && <p id="village-error" className="text-red-500 text-sm">{errors.village}</p>}
                                    </div>
                                )}
                                <div>
                                    <label htmlFor="locality" className="block mb-1 text-sm font-medium text-[#22292A]">Locality</label>
                                    <input type="text" id="locality" value={formData.locality} onChange={handleInputChange} className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.locality ? 'border-red-500' : 'border-[#B9B9C0]'}`} placeholder="Locality" aria-invalid={errors.locality ? 'true' : 'false'} aria-describedby="locality-error" />
                                    {errors.locality && <p id="locality-error" className="text-red-500 text-sm">{errors.locality}</p>}
                                </div>
                                {/* <div>
                                    <label htmlFor="postOffice" className="block mb-1 text-sm font-medium text-[#22292A]">Post Office</label>
                                    <input type="text" id="postOffice" value={formData.postOffice} onChange={handleInputChange} className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.postOffice ? 'border-red-500' : 'border-[#B9B9C0]'}`} placeholder="Post Office" aria-invalid={errors.postOffice ? 'true' : 'false'} aria-describedby="postOffice-error" />
                                    {errors.postOffice && <p id="postOffice-error" className="text-red-500 text-sm">{errors.postOffice}</p>}
                                </div> */}
                                <div>
                                    <label htmlFor="policeStation" className="block mb-1 text-sm font-medium text-[#22292A]">Police Station</label>
                                    <input type="text" id="policeStation" value={formData.policeStation} onChange={handleInputChange} className={`block w-full px-4 py-2 text-[#27272A] border-2 rounded-lg ${errors.policeStation ? 'border-red-500' : 'border-[#B9B9C0]'}`} placeholder="Police Station" aria-invalid={errors.policeStation ? 'true' : 'false'} aria-describedby="policeStation-error" />
                                    {errors.policeStation && <p id="policeStation-error" className="text-red-500 text-sm">{errors.policeStation}</p>}
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-center mb-4 mt-6 gap-2 sm:gap-0 px-2 sm:px-0">
                            <input
                                type="checkbox"
                                id="consentConfirmation"
                                checked={formData.consentConfirmation || false}
                                onChange={(e) => setFormData(prev => ({ ...prev, consentConfirmation: e.target.checked }))}
                                className="w-4 h-4 mt-0.5 sm:mt-0 shrink-0 text-[#0FA968] bg-gray-100 border-gray-300 rounded focus:ring-[#0FA968] focus:ring-2"
                            />
                            <label htmlFor="consentConfirmation" className="sm:ml-2 text-sm font-medium text-[#22292A] text-left">
                                I hereby consent to the collection and use of my personal information for patient self-service through this kiosk.
                            </label>
                        </div>
                        <div className="flex flex-col-reverse sm:flex-row justify-center items-stretch sm:items-center mt-2 mb-6 gap-3 sm:gap-4 px-4 sm:px-0">
                            <button type="button" onClick={toggleModal} className="w-full sm:w-auto px-4 py-2 bg-[#EFFEF7] text-[#0FA968] font-semibold rounded-lg shadow hover:bg-[#138F5E] hover:text-white transition duration-200 border border-[#0FA968]" disabled={loading}>
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className={`w-full sm:w-auto px-4 py-2 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                                disabled={loading}
                            >
                                {loading ? (
                                    <div className="w-6 h-6 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto"></div>
                                ) : (
                                    <div className="flex items-center justify-center space-x-2">
                                        <span>Register & Pay ₹100</span>
                                    </div>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
                {
                    isOpen && (
                        <div className="fixed inset-0 z-50 flex justify-center w-full h-full bg-[#03301F] bg-opacity-50 overflow-y-auto">
                            <div className="relative my-auto p-4 w-full max-w-lg">
                                <div className="relative bg-white rounded-lg shadow">
                                    <div className="p-4 md:p-5 text-center">
                                        <img src={Warning} alt="warning" className="mb-4 h-8 mx-auto" />
                                        <h3 className="mb-5 text-[#27272A]" style={{ fontFamily: 'Roboto', fontSize: '20px', fontWeight: '600' }}>
                                            You have Unsaved Changes.
                                        </h3>
                                        <p className="mb-5 text-[#000000]" style={{ fontFamily: 'Roboto', fontSize: '16px', fontWeight: '400' }}>
                                            Your registration is halfway. Going back to home will cancel the ongoing registration. Are you sure you want to cancel the registration?
                                        </p>
                                        <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4">
                                            <button onClick={toggleModal} className="flex w-full sm:w-auto px-4 py-3 bg-[#F7F7F8] text-[#0FA968] font-semibold rounded-lg shadow hover:bg-[#138F5E] hover:text-white transition duration-200" style={{ fontFamily: 'Roboto', fontSize: '20px', fontWeight: '600' }}>
                                                Continue to Edit
                                            </button>
                                            <Link to="/" className="flex w-full sm:w-auto justify-center px-4 py-3 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200" style={{ fontFamily: 'Roboto', 'fontSize': '20px', 'fontWeight': '600' }}>
                                                Cancel Registration
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div >
            {renderAlreadyRegisteredDialog()}
            {renderOTPScreen()}

            {/* Camera Modal */}
            {
                showCameraModal && (
                    <div className="fixed inset-0 z-50 flex justify-center items-center w-full h-full bg-black bg-opacity-90 px-4">
                        <div className="relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl p-4 sm:p-6">
                            <button
                                onClick={closeCamera}
                                className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 bg-white rounded-full p-2"
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>

                            <div className="text-center">
                                <h3 className="text-2xl font-bold text-[#22292A] mb-4">
                                    Take Patient Photo
                                </h3>

                                <div className="relative bg-black rounded-lg overflow-hidden mb-4 h-[250px] sm:h-[350px] lg:h-[400px]">
                                    <video
                                        ref={videoRef}
                                        autoPlay
                                        playsInline
                                        className="w-full h-full object-cover"
                                    />
                                    <canvas ref={canvasRef} style={{ display: 'none' }} />
                                </div>

                                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
                                    <button
                                        onClick={closeCamera}
                                        className="px-6 py-3 bg-gray-500 text-white rounded-lg font-semibold hover:bg-gray-600 transition duration-200"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={capturePhoto}
                                        className="px-6 py-3 bg-[#0FA968] text-white rounded-lg font-semibold hover:bg-[#138F5E] transition duration-200 flex items-center gap-2"
                                    >
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                                        </svg>
                                        Capture Photo
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

        </div >
    );
};

export default PatientDetailsPage;